export default {
  passingDirectness: {
    offset: 1,
    risk: {
      profiles: [
        { passingDirectness: { high: 0, low: 0.5 } },
        {},
        { passingDirectness: { high: 0.5, low: 0 } },
      ],
    },
  },

  pressingIntensity: {
    offset: 1,
    risk: {
      profiles: [
        { closingDown: { high: 0, low: 0.5 } },
        {},
        { closingDown: { high: 0.5, low: 0 } },
      ],
    },
  },

  attackingWidth: {
    offset: 1,
    risk: {
      profiles: [
        { attackingWidth: { high: 0, low: 0.5 } },
        {},
        { attackingWidth: { high: 0.5, low: 0 } },
      ],
    },
  },

  movement: {
    offset: 1,
    risk: {
      profiles: [
        { lateralMovement: { high: 0, low: 0.5 } },
        {},
        { lateralMovement: { high: 0.5, low: 0 } },
      ],
    },
  },

  dribbling: {
    offset: 1,
    risk: {
      profiles: [
        { verticalDribbling: { high: 0, low: 0.5 } },
        {},
        { verticalDribbling: { high: 0.5, low: 0 } },
      ],
    },
  },

  passingRisks: {
    offset: 1,
    risk: {
      profiles: [
        { passingRisk: { high: 0, low: 0.5 } },
        {},
        { passingRisk: { high: 0.5, low: 0 } },
      ],
    },
  },

  crossingFrequency: {
    offset: 1,
    risk: {
      profiles: [
        { crossing: { high: 0, low: 0.5 } },
        {},
        { crossing: { high: 0.5, low: 0 } },
      ],
    },
  },

  crossingPosition: {
    offset: 1,
    risk: {
      profiles: [
        { crossing: { high: 0, low: 0.5 } },
        {},
        { crossing: { high: 0.5, low: 0 } },
      ],
    },
  },

  creativeFreedom: {
    offset: 0,
    risk: {
      profiles: [
        {},
        {},
      ],
    },
  },

  shooting: {
    offset: 1,
    risk: {
      profiles: [
        { shootingRisk: { high: 0, low: 0.5 } },
        {},
        { shootingRisk: { high: 0.5, low: 0 } },
      ],
    },
  },

  marking: {
    offset: 1,
    risk: {
      profiles: [
        { marking: { high: 0, low: 0.5 } },
        {},
        { marking: { high: 0.5, low: 0 } },
      ],
    },
  },

  tackling: {
    offset: 1,
    risk: {
      profiles: [
        { tackling: { high: 0, low: 0.5 } },
        {},
        { tackling: { high: 0.5, low: 0 } },
      ],
    },
  },

  lateralDribbling: {
    offset: 1,
    risk: {
      profiles: [
        { lateralDribbling: { high: 0, low: 0.5 } },
        {},
        { lateralDribbling: { high: 0.5, low: 0 } },
      ],
    },
  },

  holdUpBall: {
    offset: 0,
    risk: {
      profiles: [
        {},
        {},
      ],
    },
  },
};
